import React, { FC, useMemo } from 'react';
import { ProgressContainerStyled } from './styled';
import { Chart } from './chart';
import { ThreeWeekLookAhead } from './three-week-look-ahead';
import { ProjectWeek } from '@bechtel/types';
import {
  UnassignedGeneralForemanId,
  AllForemanId,
  UnassignedForemanId,
  AllGeneralForemanId,
  AllSuperintendentId,
  UnassignedSuperintendentId,
  usePlanning,
  ErrorBoundary,
} from '@bechtel/client-common';
import { usePlanningPermissions } from '~/hooks';

interface ProgressProps {
  selectedProjectWeek: ProjectWeek;
}
export const Progress: FC<ProgressProps> = ({ selectedProjectWeek }) => {
  const { canViewAllCrewsProgress } = usePlanningPermissions();
  const { selectedForeman, selectedGeneralForeman, selectedSuperintendent } = usePlanning();
  const selectedCrewMember = useMemo(() => {
    if (selectedForeman && !(selectedForeman.id == AllForemanId || selectedForeman.id == UnassignedForemanId))
      return selectedForeman;
    else if (
      selectedGeneralForeman &&
      !(selectedGeneralForeman.id == AllGeneralForemanId || selectedGeneralForeman.id == UnassignedGeneralForemanId)
    )
      return selectedGeneralForeman;
    else if (
      selectedSuperintendent &&
      ((canViewAllCrewsProgress && selectedSuperintendent.id !== UnassignedSuperintendentId) ||
        (!canViewAllCrewsProgress &&
          !(
            selectedSuperintendent.id == AllSuperintendentId || selectedSuperintendent.id == UnassignedSuperintendentId
          )))
    ) {
      return selectedSuperintendent;
    }
    return null;
  }, [canViewAllCrewsProgress, selectedForeman, selectedGeneralForeman, selectedSuperintendent]);

  return (
    <ProgressContainerStyled data-testid="progress-container">
      <ErrorBoundary>
        <Chart selectedProjectWeek={selectedProjectWeek} selectedCrewMember={selectedCrewMember} />
      </ErrorBoundary>
      <ErrorBoundary>
        <ThreeWeekLookAhead selectedCrewMember={selectedCrewMember} />
      </ErrorBoundary>
    </ProgressContainerStyled>
  );
};
